import { ConfigService } from './../../../services/config.service';
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactService } from 'src/app/services/contact.service';
import { DxButtonModule, DxDataGridModule, DxTextBoxModule } from 'devextreme-angular';
import { Router } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { environment } from 'src/environments/environment';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { GpdPillComponent } from "src/app/components/gpd-pill/gpd-pill.component";

import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
@Component({
    selector: 'app-contacts-persons.page',
    imports: [CommonModule, DxDataGridModule, DxButtonModule, DxTextBoxModule, GpdButtonComponent, GpdPillComponent],
    templateUrl: './contacts-persons.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contacts-persons.page.css']
})
export class ContactsPersonsPageComponent implements OnInit {

  @ViewChild('personGrid') personGrid;

  searchValue: any;
  searchFilter: any;
  searchTerm: string = '';

  persons: any;
  contactTags: any;

  dataGridHeight: any = '60vh'
  pageBreadCrumb: any = { text: $localize`Contacts/`, href: window.location.href, layer: 0 }

  constructor(private contactService: ContactService, private router: Router, private configService: ConfigService, private appGlobals: AppGlobals, private activityLog: ActivityLogService) { }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONTACTS_PERSON });
/*     if (environment.isTestEnvironment === true) { */
      this.appGlobals.SetGlobalMenuIndex(6);
/*     } else {
      this.appGlobals.SetGlobalMenuIndex(4);
    } */
    AppGlobals.clearBreadCrumbInLocalStorage();
    this.contactService.getPersons({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.persons = result.personItems;

        for (let i = 0; i < this.persons.length; i++) {
          this.persons[i].fullAddress = this.persons[i].address + ', ' + this.persons[i].zipcode + ' ' + this.persons[i].city
        }
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });

    this.configService.getContactTags({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.contactTags = result.contactTags;
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  showDetails(e) {
    this.router.navigate(["./contacts/person/" + e.data.id]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  goToAddPerson() {
    this.router.navigate(["./contacts/addPerson"]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  getTag(item) {
    return this.contactTags.find(tag => tag.id == item).title
  }

  filterTags(filterValue, selectedFilterOperation) {
    if (!filterValue || filterValue.length === 0) {
      return null;
    }

    return function (item) {
      if (!item.tags.includes(filterValue)) {
        return false;
      }
      return true;
    }
  }

  searchValueChanged(e) {
    this.searchValue = e.value;
    this.searchFilter = [
      ['firstname', 'contains', this.searchValue],
      'or',
      ['lastname', 'contains', this.searchValue],
      'or',
      ['phone', 'contains', this.searchValue],
      'or',
      ['phoneMobile', 'contains', this.searchValue],
      'or',
      ['email', 'contains', this.searchValue],
      'or',
      ['address', 'contains', this.searchValue],
    ];
    this.applyFilter();
  }

  applyFilter() {
    this.personGrid.instance.filter([this.searchFilter]);
  }

  onCellPrepared(e) {
    if (this.searchValue) {
      let title = e.displayValue;
      if (title != null) {
        let index = title.toLowerCase().indexOf(this.searchValue.toLowerCase());
        if (index != -1) {
          let match = title.slice(index, index + this.searchValue.length);
          var searchMatchString = "<span class='search-text'>" + match + "</span>";
          title = title.split(match).join(searchMatchString);
          var result = "<div>" + title + "</div>";
          e.cellElement.innerHTML = result;
        }
      }
    }
  }


  highlightText(text: string): string {
    if (this.searchValue && typeof text === 'string') {
      let index = text.toLowerCase().indexOf(this.searchValue.toLowerCase());
      if (index != -1) {
        let match = text.slice(index, index + this.searchValue.length);
        var searchMatchString = "<span class='search-text'>" + match + "</span>";
        text = text.split(match).join(searchMatchString);
      }
    }
    return text;
  }
}
